import {BusinessRuleException, RepositoryException} from "../../../domain/exceptions/exceptions";
import {dispatchErrorBox} from "../components/mixins";

export const unexpectedErrorMessage = "Ocorreu um erro inesperado."

export async function dispatchError(e: unknown, messageOnUnexpectedError?: string): Promise<void> {
  console.error(e);
  if (e instanceof BusinessRuleException) {
    const errors = e.errors;
    const firstErrorMessage = errors[0].message;
    await dispatchErrorBox(firstErrorMessage);
  } else if (e instanceof RepositoryException) {
    await dispatchErrorBox(e.message);
  } else {
    await dispatchErrorBox(messageOnUnexpectedError ? messageOnUnexpectedError : unexpectedErrorMessage);
  }
}
